import React from "react";
import { Box, SxProps } from "@mui/material";

/* Bloc de la charte : fond #F7F5F0, contour 1.5 px noir, angles 8 px, sans
   ombre. `liseré` : couleur de domaine en repère à gauche (jamais en aplat). */
export default function Bloc({ children, lisere, sx, fin }: {
  children: React.ReactNode; lisere?: string; sx?: SxProps; fin?: boolean;
}) {
  return (
    <Box sx={{
      background: "var(--c-surface)",
      border: fin ? "1px solid var(--c-border)" : "1.5px solid var(--c-text-primary)",
      borderLeft: lisere ? `6px solid ${lisere}` : undefined,
      borderRadius: "8px",
      ...(sx as any),
    }}>
      {children}
    </Box>
  );
}

/** Petit carré de couleur de domaine (repère). */
export function CarreDomaine({ couleur, taille = 10 }: { couleur: string; taille?: number }) {
  return <Box component="span" aria-hidden sx={{ display: "inline-block", width: taille, height: taille, background: couleur, flexShrink: 0 }} />;
}
